<template>
  <!-- Root element of PhotoSwipe. Must have class pswp. -->
  <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
    <!-- Background of PhotoSwipe. 
         It's a separate element as animating opacity is faster than rgba(). -->
    <div class="pswp__bg"></div>

    <!-- Slides wrapper with overflow:hidden. -->
    <div class="pswp__scroll-wrap">
      <!-- Container that holds slides. 
            PhotoSwipe keeps only 3 of them in the DOM to save memory.
            Don't modify these 3 pswp__item elements, data is added later on. -->
      <div class="pswp__container">
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
      </div>

      <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
      <div class="pswp__ui pswp__ui--hidden">
        <div class="pswp__top-bar">
          <!--  Controls are self-explanatory. Order can be changed. -->

          <div class="pswp__counter"></div>

          <button
            class="pswp__button pswp__button--close"
            title="Close (Esc)"
          ></button>

          <!-- <button
            class="pswp__button pswp__button--share"
            title="Share"
          ></button> -->

          <button
            class="pswp__button pswp__button--fs"
            title="Toggle fullscreen"
          ></button>

          <button
            class="pswp__button pswp__button--zoom"
            title="Zoom in/out"
          ></button>

          <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
          <!-- element will get class pswp__preloader--active when preloader is running -->
          <div class="pswp__preloader">
            <div class="pswp__preloader__icn">
              <div class="pswp__preloader__cut">
                <div class="pswp__preloader__donut"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div
          class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
        >
          <div class="pswp__share-tooltip"></div>
        </div> -->

        <button
          class="pswp__button pswp__button--arrow--left"
          title="Previous (arrow left)"
        ></button>

        <button
          class="pswp__button pswp__button--arrow--right"
          title="Next (arrow right)"
        ></button>

        <div class="pswp__caption">
          <div class="pswp__caption__center"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'

import PhotoSwipe from 'photoswipe/dist/photoswipe'
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default'

export default {
  name: 'Gallery',

  props: {
    value: {
      type: String,
      required: false,
      default: null
    },

    images: {
      type: Array,
      required: false,
      default: () => {}
    },

    options: {
      type: Object,
      required: false,
      default: () => ({
        bgOpacity: 0.75
      })
    }
  },

  data() {
    return {
      photoswipe: null
    }
  },

  watch: {
    value: {
      handler(value) {
        if (value) {
          this.open({ id: value })
        } else {
          this.close()
        }
      },
      immediate: true
    }
  },

  methods: {
    open({ id }) {
      // build items array
      const items = this.images.map(image => ({
        src: image.src,
        w: window.innerWidth * 2, // times 2 -> so we can zoom
        h: window.innerHeight * 2 // times 2 -> so we can zoom
      }))

      // define options (if needed)
      const options = Object.assign({}, this.options, {
        index: this.findIndex(id)
      })

      // Initializes and opens PhotoSwipe
      this.photoswipe = new PhotoSwipe(
        this.$el,
        PhotoSwipeUIDefault,
        items,
        options
      )

      this.photoswipe.listen('close', this.onClose)

      this.photoswipe.init()
    },

    close() {
      if (this.photoswipe) {
        this.photoswipe.close()
      }
    },

    onClose() {
      this.$emit('input', null)
    },

    findIndex(id) {
      return this.images.findIndex(image => image.id === id)
    }
  }
}
</script>

<style lang="scss" scoped>
.pswp::v-deep img {
  max-width: none;
  object-fit: contain;
}
</style>
